import React, { createContext, useState, useEffect } from "react";
import ApiService, {
  initialAuthState,
} from "../components/Services/ApiServices";
import { useAuth } from "./AuthContext";

import toast, { Toaster } from "react-hot-toast";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const { isAuthenticated } = useAuth();


  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [loading, setLoading] = useState(false);
  const [updatingItemId, setUpdatingItemId] = useState(null);

  const companyCode = initialAuthState.companyCode;
  const unitCode = initialAuthState.unitCode;

  const [cartLoaded, setCartLoaded] = useState(false);



  // const checkAuth = async () => {
  //   try {

  //     const res = await ApiService.get("/auth/me");
  //     if (res?.status) {
  //       setIsLoggedIn(true);
  //     }
  //   } catch (error) {
  //     setIsLoggedIn(false);
  //   }
  // };

  const fetchCartItems = async () => {
    setCartLoaded(false);
    setLoading(true);

    try {
      if (isAuthenticated) {
        const response = await ApiService.post(
          "/cart/getCartsByClient",
          { companyCode, unitCode }
        );

        if (!response || !response.status) {
          throw new Error(response?.message || "Failed to fetch cart");
        }

        // const filteredCartItems = response.data.filter(
        //   (item) => Number(item?.client?.id) === Number(clientDbId)
        // );

        setCartItems(response.data);

      } else {
        const localItems = JSON.parse(
          localStorage.getItem("guestCartItems") || "[]"
        );
        setCartItems(localItems);
      }

    } catch (error) {
      console.error("Cart API Error:", error);

      // ✅ SHOW ERROR TO USER
      toast.dismiss();
      toast.error("Unable to load cart. Please try again.", { duration: 3000 });

      // ✅ OPTIONAL: fallback to empty cart
      setCartItems([]);

    } finally {
      setCartLoaded(true);
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   checkAuth();
  // }, []);

  useEffect(() => {
    fetchCartItems();
  }, [isAuthenticated, companyCode, unitCode]);

  const isSameVariant = (item1, item2) => {
    return (
      Number(item1.deviceId) === Number(item2.deviceId) &&
      item1.network === item2.network &&
      item1.subscription === item2.subscription &&
      item1.relayer === item2.relayer &&
      item1.state === item2.state &&
      item1.city === item2.city
    );
  };


  const updateCartItem = async (existingItem, newItem) => {
    setUpdatingItemId(existingItem.id);

    const updatedQuantity =
      // Number(existingItem.quantity || 1) +
      Number(newItem.quantity || 1);

    const updatedTotal = updatedQuantity * Number(newItem.price || 0);

    const updatedPayload = {
      ...existingItem,
      ...newItem,
      // clientId: newItem.clientId,
      // deviceId: newItem.deviceId,
      quantity: updatedQuantity,
      totalAmount: updatedTotal,
    };

    if (isAuthenticated) {
      try {
        const response = await ApiService.post(
          "/cart/handleCreateCart",
          {
            id: existingItem.id,
            ...updatedPayload,
            companyCode,
            unitCode,
          }
        );
        if (response.status) {
          toast.dismiss();

          await fetchCartItems();
          toast.success("Item updated successfully", { duration: 3000 });

        } else {
          toast.dismiss();
          toast.error("Failed to update cart", { duration: 3000 });
        }
      } catch (error) {
        console.error("Update error:", error);
        toast.dismiss();
        toast.error("Something went wrong. Please try again.", { duration: 3000 });
      } finally {
        setUpdatingItemId(null); // 🔥 STOP loader
      }
    } else {
      const guestCartItems = JSON.parse(
        localStorage.getItem("guestCartItems") || "[]"
      );

      const updatedGuest = guestCartItems.map((item) =>
        isSameVariant(item, existingItem)
          ? { ...item, quantity: updatedQuantity, totalAmount: updatedTotal }
          : item
      );

      localStorage.setItem("guestCartItems", JSON.stringify(updatedGuest));
      setCartItems(updatedGuest);

      // toast.success("Product updated successfully");
    }
  };

  const addToCart = async (item) => {
    if (!isAuthenticated) {
      toast.error("Please login to continue");
      return;
    }

    setLoading(true);

    const existingItem = cartItems.find((cartItem) =>
      isSameVariant(cartItem, item)
    );

    if (existingItem && existingItem.id) {
      setLoading(false);
      return await updateCartItem(existingItem, item);
    }

    try {
      const payload = {
        ...item,
        companyCode,
        unitCode,
      };

      const response = await ApiService.post(
        "/cart/handleCreateCart",
        payload
      );

      if (response?.status || response.status === 201) {
        toast.dismiss();
        await fetchCartItems();
        toast.success("Item added successfully!", { duration: 3000 });

      } else {
        toast.error("Failed to add product");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.dismiss();
      toast.error("Something went wrong!. Please try again.", {
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const removeFromCart = async (id) => {
    const payload = {
      id: id,
    };
    const response = await ApiService.post("/cart/deleteCartDetails", payload);
    if (response.status) {
      toast.dismiss();
      toast.success("Item deleted Successfully", { duration: 3000 });
      // fetchCartItems();
      setCartItems(prev =>
        prev.filter(item => item.id !== id)
      );
    } else {
      toast.success("Failed to delete cart item");
    }
  };

  const getTotal = () => {
    return cartItems.reduce((total, item) => {
      const basePrice = Number(item?.device?.amount) || 0;
      const discount = Number(item?.device?.discount) || 0;
      const priceAfterDiscount = basePrice - (basePrice * discount) / 100;

      return total + priceAfterDiscount * (Number(item.quantity) || 1);
    }, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems, cartLoaded, loading,
        updatingItemId, setCartItems, addToCart, updateCartItem,
        fetchCartItems, removeFromCart, getTotal,
        // clientDbId, setClientDbId
      }}
    >
      {children}
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
    </CartContext.Provider>

  );
};
